import { getArea, getLength } from "ol/sphere";

/**
 * Format area output.
 * @param {Polygon} polygon The polygon.
 * @return {string} Formatted area.
 */
export const geoFormatArea = (polygon, format = "m") => {
  const area = getArea(polygon);
  let output;

  // if (area > 10000) {
  //   output = Math.round((area / 1000000) * 100) / 100 + ' km<sup>2</sup>';
  // } else {
  //   output = Math.round(area * 100) / 100 + ' m<sup>2</sup>';
  // }

  if (format === "km") {
    output = Math.round((area / 1000000) * 100) / 100;
  } else {
    output = Math.round(area * 100) / 100;
  }
  return output;
};

/**
 * Format length output.
 * @param {LineString} line The line.
 * @return {string} The formatted length.
 */
export const geoFormatLength = function (line, format = "m") {
  const length = getLength(line);
  let output;

  // if (length > 100) {
  //     output = Math.round((length / 1000) * 100) / 100 + ' ' + 'km';
  // } else {
  //     output = Math.round(length * 100) / 100 + ' ' + 'm';
  // }

  if (format === "km") {
    output = Math.round((length / 1000) * 100) / 100;
  } else {
    output = Math.round(length * 100) / 100;
  }
  return output;
};

/**
 * Get label for type of geometry
 * @param {number} type The type of geometry.
 * @return {string} The label.
 */
export const getGeomTypeLabel = (type) => {
  let label;
  switch (type) {
    case 1:
      label = "Albero";
      break;
    case 2:
      label = "Filare";
      break;
    case 3:
      label = "Area boschiva";
      break;
    default:
      label = "";
  }

  return label;
};

/**
 * Transform degrees in N, NE, E, SE, S, SW, W, NW
 * @param {number} type The type of geometry.
 * @return {string} The label.
 */
export const degreeToCompass = (deg) => {
  let compassName = [
    "N",
    "N-NE",
    "NE",
    "E-NE",
    "E",
    "E-SE",
    "SE",
    "S-SE",
    "S",
    "S-SW",
    "SW",
    "W-SW",
    "W",
    "W-NW",
    "NW",
    "N-NW",
    "N",
  ];
  let compass = Math.round(deg / 22.5);
  return compassName[compass];
};
